import { render, staticRenderFns } from "./frasDigi.vue?vue&type=template&id=5bea957f"
import script from "./frasDigi.vue?vue&type=script&lang=js"
export * from "./frasDigi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports